import { Typography } from "@mui/material";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import type { MessageApiResponse } from "@services/message-service/types";
import { format } from "date-fns";
import {
  BubblePaper,
  BubbleWrapper,
  FileUploadHighlight,
  SenderLabel,
  Timestamp,
} from "./Chat.styles";

interface MessageBubbleProps {
  message: MessageApiResponse;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const { user } = useAuthStore();
  const isIncoming = message.authorId !== user?.email;
  const isOutgoing = message.authorId === user?.email;
  const isFile = !!message.fileName;

  const align = isIncoming ? "flex-start" : "flex-end";
  const alignTimeStamp = isIncoming ? "left" : "right";

  let backgroundColor = "#E5E7EB"; // incoming default
  let textColor = "#111827";

  if (isOutgoing) {
    backgroundColor = "#0052CC";
    textColor = "#FFFFFF";
  }

  if (isFile) {
    backgroundColor = "#E6F0FF";
    textColor = "#111827";
  }

  return (
    <BubbleWrapper align={align} spacing={0.5}>
      {/* Sender name (incoming only) */}
      {isIncoming && message.authorName && (
        <SenderLabel variant="caption">{message.authorName}</SenderLabel>
      )}

      {/* Actual message bubble */}
      <BubblePaper elevation={0} bgcolorValue={backgroundColor} textcolor={textColor}>
        {isFile && message.fileName ? (
          <Typography variant="body2">
            {message.fileName} <FileUploadHighlight>has been uploaded</FileUploadHighlight>
          </Typography>
        ) : (
          <Typography variant="body1">{message.message}</Typography>
        )}
      </BubblePaper>

      {/* Timestamp */}
      {message.creationDateTime && (
        <Timestamp variant="caption" align={alignTimeStamp}>
          {format(message.creationDateTime, "MM/dd/yyyy HH:mm")}
        </Timestamp>
      )}
    </BubbleWrapper>
  );
};

export default MessageBubble;
